import {Base} from "@/api/Base"

export class OtherDelete extends Base {
    path = "other/delete"
}